<template>
<el-popover ref="popover" :placement="placement" :trigger="trigger" popper-class="label-position-popup" width="70" :visible-arrow="false">
  <el-radio-group v-model="labelPosition" @change="handleChange">
  <el-row type="flex" justify="space-between" align="middle">
    <el-tooltip :content="MapConst.LABEL_POSITION.LT" placement="top-end">
      <el-radio :label="'LT'"></el-radio>
    </el-tooltip>
    <el-tooltip :content="MapConst.LABEL_POSITION.CT" placement="top">
      <el-radio :label="'CT'"></el-radio>
    </el-tooltip>
    <el-tooltip :content="MapConst.LABEL_POSITION.RT" placement="top-start">
      <el-radio :label="'RT'"></el-radio>
    </el-tooltip>
  </el-row>
  <el-row type="flex" justify="space-between" align="middle">
    <el-tooltip :content="MapConst.LABEL_POSITION.LM" placement="left">
      <el-radio :label="'LM'"></el-radio>
    </el-tooltip>
    <el-tooltip :content="MapConst.LABEL_POSITION.RM" placement="right">
      <el-radio :label="'RM'"></el-radio>
    </el-tooltip>
  </el-row>
  <el-row type="flex" justify="space-between" align="middle">
    <el-tooltip :content="MapConst.LABEL_POSITION.LB" placement="bottom-end">
      <el-radio :label="'LB'"></el-radio>
    </el-tooltip>
    <el-tooltip :content="MapConst.LABEL_POSITION.CB" placement="bottom">
      <el-radio :label="'CB'"></el-radio>
    </el-tooltip>
    <el-tooltip :content="MapConst.LABEL_POSITION.RB" placement="bottom-start">
      <el-radio :label="'RB'"></el-radio>
    </el-tooltip>
  </el-row>
  </el-radio-group>
  <el-input v-model="MapConst.LABEL_POSITION[labelPosition]" slot="reference" readonly style="width: 203px;"></el-input>
</el-popover>
</template>

<script>
import MapConst from '@/constants/topologymap';

export default {
  name: 'WLabelPositionSelect',
  props: {
    value: {
      type: String,
    },
    placement: {
      type: String,
      default: 'top',
    },
    trigger: {
      type: String,
      default: 'click',
    },
  },
  data() {
    return {
      MapConst,
      /**
       * 라벨 위치
       * @type {String}
       */
      labelPosition: this.value,
    };
  },
  watch: {
    value(val) {
      this.labelPosition = val;
    },
  },
  methods: {
    /**
     * 라벨 위치 값이 변경되면 바인딩 된 데이터를 동기화시킨다.
     * @author KangBonghun(toto1323)
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    handleChange(value) {
      this.$emit('input', value);

      this.$refs.popover.doClose();
    },
  },
};
</script>
<style>
.label-position-popup {
  min-width: fit-content;
}
.label-position-popup .el-row {
  margin-bottom: 10px;
}
.label-position-popup .el-row:last-child {
  margin-bottom: 0;
}
.label-position-popup .el-radio+.el-radio {
  margin-left: 15px;
}
.label-position-popup .el-radio__label {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/property/LabelPositionSelect.vue